var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c(_vm.hElement,{tag:"component",domProps:{"textContent":_vm._s(_vm.title)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }